import * as defaultImport from "@splunk/visualizations/Line";
export * from "@splunk/visualizations/Line";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
